import {mapGetters} from "vuex";
import {VueSlideToggle} from 'vue-slide-toggle'

export default {
    name: 'course-sidebar-skills',
    components: {
        VueSlideToggle
    },
    props: ['points'],
    data() {
        return {
            hasShowMore: false,
            series: [{
                name: this.$t('points'),
                data: []
            }],
            chartOptions: {
                dataLabels: {
                    enabled: false,
                    textLength: '30',
                    lengthAdjust: 'spacing'
                },
                fill: {
                    opacity: 1,
                    colors: ['rgba(184, 63, 57, 0.1)']
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ['#B83F39'],
                    dashArray: 0
                },
                plotOptions: {
                    radar: {
                        size: 70,
                        polygons: {
                            strokeColors: 'rgba(17, 17, 17, 0.15)',
                            fill: {
                                colors: ['#F5F5F5', 'rgba(255, 255, 255, 0.65)']
                            }
                        }
                    },
                },
                colors: ['#B83F39'],
                markers: {
                    size: 3,
                    hover: {
                        size: 6
                    }
                },
                tooltip: {
                    enabled: false,
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                xaxis: {
                    categories: ['Communication update Ultra', 'Management nice', 'Marketing ultra nice', 'Graphic Design', 'Direct Sales', 'Promotion'],
                    hideOverlappingLabels: true,
                    trim: true,
                    labels: {
                        show: true,
                        rotate: -45,
                        rotateAlways: true,
                        hideOverlappingLabels: false,
                        showDuplicates: true,
                        trim: true,
                        minHeight: 100,
                        maxHeight: 220,
                        style: {
                            colors: ['#ccc'],
                            fontSize: '22px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 900,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                        offsetX: 0,
                        offsetY: 0,
                    },
                    axisTicks: {
                        show: true,
                        color: 'red'
                    },
                },
                yaxis: {
                    tickAmount: 0,
                    labels: {
                        formatter: function (val, i) {
                            return ''
                        }
                    }
                },
            }
        }
    },
    computed: {
        ...mapGetters({
            currentCourse: 'courses/currentItem',
        }),
    },
    mounted() {
        this.updateSeriesLine();
        this.updateLabels();

        setTimeout(() => {
            this.addMultiRowText();
        }, 300)

    },
    methods: {
        addMultiRowText() {
            let textElements = document.querySelectorAll('#chart text');
            textElements.forEach(element => {
                let elementX = element.getAttribute("x");
                let text = element.innerHTML;
                let textTemplate = ``;
                let dy = 15;

                if (!text) return;
                text.split(' ').forEach((textEl, index) => {
                    textTemplate += `<tspan x="${elementX}" dy="${index === 0 ? 0 : dy}">${textEl}</tspan>`;
                });

                element.innerHTML = textTemplate;
            })
        },

        updateSeriesLine() {
            this.$refs.apexchart.updateSeries([{
                data: this.points.map(function (name) {
                    return name.points;
                })
            }], false, true)
        },
        updateLabels() {
            this.$refs.apexchart.updateOptions({
                xaxis: {
                    categories: this.points.map(function (name) {
                        return name.skill.data.name;
                        // return name.skill.data.name.slice(0,12);
                    }),
                }
            }, false, true)
        }
    }
}
